module.exports = __webpack_public_path__ + "media/site_templates/www.localconcreters.com.au/images/feature_3-fcaba221dcc4e41bc1d38dca0bd3db00.jpeg";